// Vendor Libraries
import { ElementRef } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
// Utils / Constants
import { ASC } from 'NewAngular/constants/core.constants';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { NAME_IN_LEGEND_OPTIONS } from 'ChartApp/ts/features/charts-shared/constants';
import { PARTNER_OPTIONS, PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
import { SCATTER_PLOT_INTERACTIVE_CHART_OPTIONS } from 'ChartApp/ts/features/scatter-plot-page-shared/constants';
// NgRx actions / selectors
import { setChartType } from 'ChartApp/ts/apps/scatter-plot/state/chart-type/chart-type.action';
// NgRx store actions / selectors
import { getChartType } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { setChartOption, setNameInLegend, } from 'ChartApp/ts/apps/scatter-plot/state/chart-options/chart-options.actions';
import { setPresentationOption } from 'ChartApp/ts/apps/scatter-plot/state/presentation-options/presentation-options.actions';
import { ChartSortColumn } from 'ChartApp/ts/enums/chart-common.enum';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
import { ScatterPlotChartOptionValue, ScatterPlotChartSize, ScatterPlotChartType, ScatterPlotPlotOptionValue, ScatterPlotPlotType, ScatterPlotPresentationOptionValue, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Services
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { ScatterPlotAppStateManager } from 'ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service';
import { ScatterPlotFolderableCollectionService } from 'ChartApp/ts/apps/scatter-plot/services/scatter-plot-folderable-collection.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { SelectedScatterPlotService } from 'ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
import { SavedScatterPlotService } from 'NewAngular/features/components/saved-items/services/saved-scatter-plot.service';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/apps/scatter-plot/services/scatter-plot-folderable-collection.service";
import * as i2 from "@ngrx/store";
import * as i3 from "ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service";
import * as i4 from "@angular/common";
import * as i5 from "ChartApp/ts/features/charts-shared/components/chart-options/chart-options.component";
import * as i6 from "ChartApp/ts/features/charts-shared/components/chart-type-toggle/chart-type-toggle.component";
import * as i7 from "FoldersApp/features/folders-shared/folderable-open-saved-modal/folderable-open-saved-modal.component";
import * as i8 from "FoldersApp/features/folders-shared/folderable-rename-modal/folderable-rename-modal.component";
import * as i9 from "FoldersApp/features/folders-shared/folderable-save-as-modal/folderable-save-as-modal.component";
import * as i10 from "FoldersApp/features/folders-shared/folderable-sharing-modal/folderable-sharing-modal.component";
import * as i11 from "FoldersApp/features/folders-shared/folderable-delete-modal/folderable-delete-modal.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i14 from "../../../../../../../../securities/static/securities/ts/features/module-upsell/module-upsell.component";
import * as i15 from "../../../../../../../../../ycharts/static/ts/features/components/page-error-message/page-error-message.component";
import * as i16 from "../../../../../../../../../ycharts/static/ts/features/components/side-menu/side-menu.component";
import * as i17 from "../../../../features/scatter-plot-page-shared/components/scatter-plot-chart-interactive/scatter-plot-chart-interactive.component";
import * as i18 from "../../../../features/scatter-plot-page-shared/components/scatter-plot-controls/scatter-plot-controls.component";
import * as i19 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/simple-input/simple-input.component";
import * as i20 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i21 from "../../../../../../../../../ycharts/static/ts/features/components/toast-messages/toast-messages.component";
import * as i22 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i23 from "ChartApp/ts/apps/scatter-plot/components/scatter-plot-folderable-list-item/scatter-plot-folderable-list-item.component";
import * as i24 from "ChartApp/ts/apps/scatter-plot/components/scatter-plot-folderable-open-saved-filter/scatter-plot-folderable-open-saved-filter.component";
import * as i25 from "ChartApp/ts/apps/scatter-plot/components/scatter-plot-chart-presentation/scatter-plot-chart-presentation.component";
import * as i26 from "../scatter-plot-header/scatter-plot-header.component";
const _c0 = (a0, a1) => ({ "is-panel-sidebar-shown": a0, "is-panel-sidebar-hidden": a1 });
const _c1 = () => ({ button: "btn btn-secondary btn-block" });
function ScatterPlotPageComponent_ycn_scatter_plot_header_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-scatter-plot-header", 35);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("securityPageType", ctx_r1.securityPageType);
} }
function ScatterPlotPageComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37)(2, "div", 38);
    i0.ɵɵtext(3, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ycn-simple-input", 39);
    i0.ɵɵlistener("handler", function ScatterPlotPageComponent_div_22_Template_ycn_simple_input_handler_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setPresentationOption(ctx_r1.ScatterPlotPresentationOption.title, $event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 40)(6, "div", 38);
    i0.ɵɵtext(7, "Notes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "ycn-simple-input", 41);
    i0.ɵɵlistener("handler", function ScatterPlotPageComponent_div_22_Template_ycn_simple_input_handler_8_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setPresentationOption(ctx_r1.ScatterPlotPresentationOption.note, $event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 42)(10, "ycn-single-select-dropdown", 43);
    i0.ɵɵlistener("changeHandler", function ScatterPlotPageComponent_div_22_Template_ycn_single_select_dropdown_changeHandler_10_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setPresentationOption(ctx_r1.ScatterPlotPresentationOption.size, $event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("value", ctx_r1.presentationOptions.title)("isClearable", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("value", ctx_r1.presentationOptions.note)("isClearable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(7, _c1))("selectedValue", ctx_r1.chartSize)("config", ctx_r1.chartSizesDropdownConfig);
} }
function ScatterPlotPageComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ScatterPlotPageComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-scatter-plot-chart-interactive");
} }
function ScatterPlotPageComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-scatter-plot-chart-presentation");
} }
function ScatterPlotPageComponent_ng_template_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-scatter-plot-folderable-list-item", 44);
} if (rf & 2) {
    const folderable_r4 = ctx.folderable;
    const ancestorInfo_r5 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r4)("ancestorInfo", ancestorInfo_r5);
} }
function ScatterPlotPageComponent_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1, " Get Started.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Create a new Scatter Plot");
    i0.ɵɵelementEnd()();
} }
function ScatterPlotPageComponent_ng_template_43_ycn_loading_symbol_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 47);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading Scatter Plots...");
} }
function ScatterPlotPageComponent_ng_template_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ScatterPlotPageComponent_ng_template_43_ycn_loading_symbol_0_Template, 1, 1, "ycn-loading-symbol", 46);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.scatterPlotFolderableCollectionService.loading);
} }
function ScatterPlotPageComponent_ng_template_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-scatter-plot-folderable-open-saved-filter");
} }
const scatterPlotFolderableAppConfig = {
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Scatter Plots',
};
/**
 * Scatter Plot Page Component
 *
 * This is top level bootstrapped component for the scatter plot app.
 */
export class ScatterPlotPageComponent {
    constructor(scatterPlotFolderableCollectionService, el, store, scatterPlotAppStateService) {
        this.scatterPlotFolderableCollectionService = scatterPlotFolderableCollectionService;
        this.el = el;
        this.store = store;
        this.scatterPlotAppStateService = scatterPlotAppStateService;
        this.defaultOnly = false;
        this.ScatterPlotChartType = ScatterPlotChartType;
        this.ScatterPlotPresentationOption = ScatterPlotPresentationOptionValue;
        this.isAlive = true;
        this.showSidebar = true;
        this.chartOptionsConfig = {
            title: {
                label: 'Chart Options',
            },
            list: [
                ...SCATTER_PLOT_INTERACTIVE_CHART_OPTIONS,
                // Presentation
                {
                    label: 'Show Legend On Chart',
                    value: ScatterPlotChartOptionValue.displayLegendOnChart,
                    selected: false,
                    presentationOnly: true,
                },
                {
                    label: 'Show Performance Disclosure',
                    value: ScatterPlotChartOptionValue.performanceDisclosure,
                    selected: false,
                    presentationOnly: true,
                },
            ],
        };
        this.nameInLegendOptionsConfig = {
            title: {
                label: 'Name in Legend',
            },
            list: [...NAME_IN_LEGEND_OPTIONS],
        };
        this.chartSize = ScatterPlotChartSize.basic_2000;
        this.chartSizesDropdownConfig = {
            title: {
                label: 'Chart Sizes',
            },
            list: PARTNER_OPTIONS,
        };
        // Fetching Data
        this.presentationOptions = {
            [ScatterPlotPresentationOptionValue.note]: '',
            [ScatterPlotPlotOptionValue.size]: PARTNER_OPTION_DEFAULT,
            [ScatterPlotPresentationOptionValue.title]: '',
            [ScatterPlotPresentationOptionValue.legendOrientation]: 'vertical',
        };
        // Actions
        this.setChartTypeAction = setChartType;
        this.USER = window.USER;
        // Folders
        this.ChartSortColumn = ChartSortColumn;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [ChartSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [ChartSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [ChartSortColumn.OWNER]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.SAVED_ITEM_FILTER_DEFAULT = {
            owner: {
                me: true,
                shared_with_me: true,
                public: true,
            },
            page: 1,
            sortColumn: 'user_modify',
            sortDirection: ASC,
            name: '',
        };
        // Defined as an arrow function so that this refers to the component
        this.mapStateToComponent = (state) => {
            this.chartType = getChartType(state);
            // Update the dropdown items to match what is in the scatter plot state
            this.chartOptionsConfig.list = this.chartOptionsConfig.list.map((chartOption) => {
                return this.updateChartOptionConfigItem(chartOption, state.scatterPlot[chartOption.value], state.scatterPlot.plotType);
            });
            this.nameInLegendOptionsConfig.list = this.nameInLegendOptionsConfig.list.map((nameInLegendOption) => {
                return {
                    ...nameInLegendOption,
                    selected: state.scatterPlot.nameInLegend === nameInLegendOption.value,
                };
            });
            // Create a new reference to the object to trigger Angular change detection.
            // This will update the chart/label options displayed.
            this.chartOptionsConfig = { ...this.chartOptionsConfig };
            this.nameInLegendOptionsConfig = { ...this.nameInLegendOptionsConfig };
            this.chartSize = state.scatterPlot.size || ScatterPlotChartSize.basic_2000;
            // Update the presentation option input fields to match what is in the scatter plot state
            this.presentationOptions[ScatterPlotPresentationOptionValue.title] = state.scatterPlot.title;
            this.presentationOptions[ScatterPlotPresentationOptionValue.note] = state.scatterPlot.note;
            this.presentationOptions[ScatterPlotPresentationOptionValue.size] = state.scatterPlot.size;
        };
        this.securityPageType = el.nativeElement.getAttribute('securityPageType');
        this.defaultOnly = el.nativeElement.getAttribute('defaultOnly') === 'True';
        this.scatterPlotAppStateService.initAppState();
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    updateChartOptions(newOption) {
        const newOptionProps = {
            label: newOption.label,
            value: newOption.value,
            selected: !!newOption.selected,
        };
        this.store.dispatch(setChartOption({ chartOption: newOptionProps }));
    }
    updateNameInLegend(newOption) {
        this.store.dispatch(setNameInLegend({ nameInLegend: newOption }));
    }
    /**
     * Enable/disable and select chart options depending on user input and the plot type.
     *
     * @param chartOption: The chart option object from the chart options dropdown.
     * @param selected: A boolean describing whether the user selected the given chart option.
     * @param plotType: A string describing the plot type of the scatter plot.
     * @return An updated chart object.
     */
    updateChartOptionConfigItem(chartOption, selected, plotType) {
        const newChartOption = { ...chartOption };
        newChartOption.selected = selected;
        /* eslint-disable no-param-reassign */
        // The "age" of data points cannot be shown relative to other data points in the same series because only
        // one point for each series is displayed for point_in_time plots.
        if (chartOption.value === ScatterPlotChartOptionValue.displayColorRange) {
            newChartOption.selected = plotType === ScatterPlotPlotType.pointInTime ? false : selected;
            newChartOption.disabled = plotType === ScatterPlotPlotType.pointInTime;
        }
        // Because x/y data cannot be displayed for multiple points, it cannot be displayed for timeseries plots.
        else if (chartOption.value === ScatterPlotChartOptionValue.displayXYDataInLegend) {
            newChartOption.selected = plotType === ScatterPlotPlotType.timeseries ? false : selected;
            newChartOption.disabled = plotType === ScatterPlotPlotType.timeseries;
        }
        /* eslint-enable no-param-reassign */
        return newChartOption;
    }
    getChartOptionsConfigToDisplay(dropdownConfig) {
        let { list } = dropdownConfig;
        // When in interactive mode, do not display presentation mode options
        if (this.chartType === ScatterPlotChartType.interactive) {
            list = dropdownConfig.list.filter((item) => {
                return !('presentationOnly' in item);
            });
        }
        return {
            ...dropdownConfig,
            list,
        };
    }
    setPresentationOption(option, value) {
        this.store.dispatch(setPresentationOption({ option, value }));
    }
}
ScatterPlotPageComponent.ɵfac = function ScatterPlotPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotPageComponent)(i0.ɵɵdirectiveInject(i1.ScatterPlotFolderableCollectionService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.ScatterPlotAppStateManager)); };
ScatterPlotPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotPageComponent, selectors: [["ycn-scatter-plot-page"]], standalone: false, features: [i0.ɵɵProvidersFeature([
            FolderExpansionService,
            ScatterPlotAppStateManager,
            ScatterPlotFolderableCollectionService,
            SelectedScatterPlotService,
            ToastMessagesService,
            { provide: BaseSavedItemService, useExisting: SavedScatterPlotService },
            { provide: SelectedFolderableService, useExisting: SelectedScatterPlotService },
            { provide: FolderableCollectionServiceBase, useExisting: ScatterPlotFolderableCollectionService },
            { provide: AppStateManager, useExisting: ScatterPlotAppStateManager },
            { provide: FOLDERABLE_APP_CONFIG, useValue: scatterPlotFolderableAppConfig },
        ])], decls: 47, vars: 27, consts: [["InteractiveChart", ""], ["PresentationChart", ""], ["listItemFragment", ""], ["userHasNoDataFragment", ""], ["loadingFragment", ""], ["filterFragment", ""], [1, "page-content"], [1, "page", "page-fc"], [1, "full-height"], [3, "securityPageType", 4, "ngIf"], [1, "page-body", "panel", "panel-with-sidebar", 3, "ngClass"], [1, "panel-wrap", "row"], [1, "page-body", 3, "closeHandler", "defaultOnly"], [1, "panel-content-wrap"], [1, "panel-content"], [1, "row", "form-row", "justify-content-between"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "panel-sidebar-toggler", "panel-sidebar-toggler-open", 3, "click"], ["ycnTooltip", "", 3, "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "chart-options-cover", "col-i-3"], [3, "chartOptionChangeHandler", "nameInLegendChangeHandler", "chartOptionsConfig", "nameInLegendOptionsConfig"], [1, "col"], [1, "view-select-cover"], [1, "form-inline", "justify-content-end"], [1, "form-label"], [3, "setChartTypeAction"], ["class", "row form-row", 4, "ngIf"], ["id", "chart", 1, "row", "row-full-height"], [1, "col-12"], [1, "chart-cover", 2, "width", "100%"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "title"], [3, "deleteFileErrorMessage"], [3, "modalHeader"], [3, "modalHeader", "columnConfig", "sortableColumns", "userPreferenceFilterKey", "filterDefault", "listItemFragment", "filterFragment", "userHasNoDataFragment", "loadingFragment"], [3, "securityPageType"], [1, "row", "form-row"], [1, "col-lg-4", "chart-title-cover", "form-inline"], [1, "form-label", "user-select-none"], ["buttonText", "Update", "placeholder", "Enter Title", 1, "input-group", 3, "handler", "value", "isClearable"], [1, "col-md-6", "col-lg-4", "chart-notes-cover", "form-inline"], ["buttonText", "Update", "placeholder", "Enter Notes", 1, "input-group", 3, "handler", "value", "isClearable"], [1, "col-md-6", "col-lg-4"], ["placeholderText", "Chart Sizes", 1, "dropdown", 3, "changeHandler", "customCssClasses", "selectedValue", "config"], [3, "folderable", "ancestorInfo"], [1, "get-started", "flex-auto"], ["data-test-id", "saved-scatter-plots-loading-symbol", 3, "loaderMessage", 4, "ngIf"], ["data-test-id", "saved-scatter-plots-loading-symbol", 3, "loaderMessage"]], template: function ScatterPlotPageComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelement(0, "ycn-page-error-message");
        i0.ɵɵelementStart(1, "main", 6)(2, "div", 7)(3, "div", 8);
        i0.ɵɵtemplate(4, ScatterPlotPageComponent_ycn_scatter_plot_header_4_Template, 1, 1, "ycn-scatter-plot-header", 9);
        i0.ɵɵelementStart(5, "div", 10)(6, "div", 11)(7, "ycn-scatter-plot-controls", 12);
        i0.ɵɵlistener("closeHandler", function ScatterPlotPageComponent_Template_ycn_scatter_plot_controls_closeHandler_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showSidebar = false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 13)(9, "div", 14)(10, "div", 15)(11, "div", 16);
        i0.ɵɵlistener("click", function ScatterPlotPageComponent_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showSidebar = true); });
        i0.ɵɵelementStart(12, "span", 17);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(13, "svg", 18);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(14, "div", 19)(15, "ycn-chart-options", 20);
        i0.ɵɵlistener("chartOptionChangeHandler", function ScatterPlotPageComponent_Template_ycn_chart_options_chartOptionChangeHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateChartOptions($event)); })("nameInLegendChangeHandler", function ScatterPlotPageComponent_Template_ycn_chart_options_nameInLegendChangeHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updateNameInLegend($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "div", 21)(17, "div", 22)(18, "div", 23)(19, "div", 24);
        i0.ɵɵtext(20, "Presentation View");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "ycn-chart-type-toggle", 25);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(22, ScatterPlotPageComponent_div_22_Template, 11, 8, "div", 26);
        i0.ɵɵelementStart(23, "div", 27)(24, "div", 28)(25, "div", 29);
        i0.ɵɵtemplate(26, ScatterPlotPageComponent_ng_container_26_Template, 1, 0, "ng-container", 30)(27, ScatterPlotPageComponent_ng_template_27_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(29, ScatterPlotPageComponent_ng_template_29_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelement(31, "ycn-module-upsell", 31);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(32, "ycn-side-menu")(33, "ycn-toast-messages")(34, "ycn-folderable-delete-modal", 32)(35, "ycn-folderable-rename-modal")(36, "ycn-folderable-sharing-modal")(37, "ycn-folderable-save-as-modal", 33)(38, "ycn-folderable-open-saved-modal", 34);
        i0.ɵɵtemplate(39, ScatterPlotPageComponent_ng_template_39_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(41, ScatterPlotPageComponent_ng_template_41_Template, 5, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(43, ScatterPlotPageComponent_ng_template_43_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(45, ScatterPlotPageComponent_ng_template_45_Template, 1, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const InteractiveChart_r6 = i0.ɵɵreference(28);
        const PresentationChart_r7 = i0.ɵɵreference(30);
        const listItemFragment_r8 = i0.ɵɵreference(40);
        const userHasNoDataFragment_r9 = i0.ɵɵreference(42);
        const loadingFragment_r10 = i0.ɵɵreference(44);
        const filterFragment_r11 = i0.ɵɵreference(46);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c0, ctx.showSidebar, !ctx.showSidebar));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("tooltipTitle", "Show Controls");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-open-arrow");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("chartOptionsConfig", ctx.getChartOptionsConfigToDisplay(ctx.chartOptionsConfig))("nameInLegendOptionsConfig", ctx.nameInLegendOptionsConfig);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("setChartTypeAction", ctx.setChartTypeAction);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.chartType === ctx.ScatterPlotChartType.presentation);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.chartType === ctx.ScatterPlotChartType.interactive)("ngIfThen", InteractiveChart_r6)("ngIfElse", PresentationChart_r7);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("title", "Scatter Plot");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("deleteFileErrorMessage", "There was an error deleting the scatter plot.");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("modalHeader", "Save Scatter Plot As");
        i0.ɵɵadvance();
        i0.ɵɵproperty("modalHeader", "Open Saved Scatter Plot")("columnConfig", ctx.SAVED_ITEM_COLUMN_CONFIG)("sortableColumns", ctx.ChartSortColumn)("userPreferenceFilterKey", "scatter_plot_list_modal_filters")("filterDefault", ctx.SAVED_ITEM_FILTER_DEFAULT)("listItemFragment", listItemFragment_r8)("filterFragment", filterFragment_r11)("userHasNoDataFragment", userHasNoDataFragment_r9)("loadingFragment", loadingFragment_r10);
    } }, dependencies: [i4.NgClass, i4.NgIf, i5.ChartOptionsComponent, i6.ChartTypeToggleComponent, i7.FolderableOpenSavedModalComponent, i8.FolderableRenameModalComponent, i9.FolderableSaveAsModalComponent, i10.FolderableSharingModalComponent, i11.FolderableDeleteModalComponent, i12.IconDirective, i13.LoadingSymbolComponent, i14.ModuleUpsellComponent, i15.PageErrorMessageComponent, i16.SideMenuComponent, i17.ScatterPlotChartInteractiveComponent, i18.ScatterPlotControlsComponent, i19.SimpleInputComponent, i20.SingleSelectDropdownComponent, i21.ToastMessagesComponent, i22.TooltipDirective, i23.ScatterPlotFolderableListItemComponent, i24.ScatterPlotFolderableOpenSavedFilterComponent, i25.ScatterPlotChartPresentationComponent, i26.ScatterPlotHeaderComponent], encapsulation: 2 });
